module.exports = __webpack_public_path__ + "img/j-a.5a583956.png";